import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  MenuItem,
} from "@mui/material";
import axios from "../../utils/axiosInstance";
import { toast } from "react-toastify";
import { sortAlphabetically } from "../../utils/sortAlphabetically";
import { getUIDescription } from "../SiteAdmin/customerGroupDetails/AssigningCustomerGroupDevice";
export default function AddReportGroup({ open, onClose, onAdded }) {
  const [reportGroupName, setReportGroupName] = useState("");
  const [reportGroupDesc, setReportGroupDesc] = useState("");
  const [customerGroupId, setCustomerGroupId] = useState("");
  const [groups, setGroups] = useState([]);
  const [loadingGroups, setLoadingGroups] = useState(false);

  useEffect(() => {
    const fetchGroups = async () => {
      try {
        setLoadingGroups(true);
        const response = await axios.get(
          `${process.env.REACT_APP_API_GATEAWAY}/groups?type=customer`,
          {
            params: { companyId: process.env.REACT_APP_COMPANY_ID },
          }
        );
        const sortedData = sortAlphabetically(response.data, "name");
        setGroups(sortedData);
      } catch (err) {
        console.error("❌ Error fetching groups:", err);
      } finally {
        setLoadingGroups(false);
      }
    };

    fetchGroups();
  }, []);

  const handleSubmit = async () => {
    if (!reportGroupName || !customerGroupId) {
      toast.warning("Please fill all required fields");
      return;
    }

    try {
      const payload = {
        name: reportGroupName,
        description: reportGroupDesc,
        groupId: customerGroupId,
        companyId: process.env.REACT_APP_COMPANY_ID,
        UI_Description: `${getUIDescription()}\n Add report Group`,
      };

      await axios.post(
        `${process.env.REACT_APP_API_GATEAWAY}/reportGroups`,
        payload
      );

      toast.success("Report group created successfully!");
      setReportGroupName("");
      setReportGroupDesc("");
      setCustomerGroupId("");
      onClose();
      if (onAdded) onAdded();
    } catch (err) {
      console.error("❌ Error creating report group:", err);
      toast.error("Failed to create report group");
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Add Report Group</DialogTitle>
      <DialogContent>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            gap: 4,
            mt: 1,
          }}
        >
          <TextField
            sx={{ flex: 1 }}
            label="Report Group Name *"
            value={reportGroupName}
            onChange={(e) => setReportGroupName(e.target.value)}
          />
          <TextField
            sx={{ flex: 1 }}
            label="Report Group Description"
            value={reportGroupDesc}
            onChange={(e) => setReportGroupDesc(e.target.value)}
          />
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            gap: 4,
            mt: 4,
          }}
        >
          <TextField
            select
            label="Customer Group *"
            value={customerGroupId}
            onChange={(e) => setCustomerGroupId(e.target.value)}
            disabled={loadingGroups}
            fullWidth
          >
            {groups.length > 0 ? (
              groups.map((group) => (
                <MenuItem key={group.id} value={group.id}>
                  {group.name}
                </MenuItem>
              ))
            ) : (
              <MenuItem disabled>
                {loadingGroups ? "Loading groups..." : "No groups available"}
              </MenuItem>
            )}
          </TextField>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          sx={{
            borderRadius: 0, // ✅ remove rounding
          }}
          onClick={onClose}
          color="white"
        >
          Cancel
        </Button>
        <Button variant="contained" color="primary" onClick={handleSubmit}>
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
}
